exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".personalInfoContent[data-v-48a7cdef] {\n  width: 100%;\n  min-height: 0;\n  overflow: hidden;\n  margin-top: 10px;\n}\n", ""]);

// exports
